import axios, { AxiosInstance } from "axios";
import { useNavigate } from "react-router-dom";

const useApi = () => {
  const navigate = useNavigate();

  const api: AxiosInstance = axios.create({
    baseURL: process.env.REACT_APP_API_URL,
    headers: {
      "Content-Type": "application/json",
    },
    withCredentials: true, // send cookies on every request
  });

  api.interceptors.request.use((config) => {
    const tokenStr = localStorage.getItem("token");
    if (tokenStr) {
      try {
        const token = JSON.parse(tokenStr);
        if (token?.access_token) {
          config.headers.Authorization = `Bearer ${token.access_token}`;
        }
      } catch {
        // token inválido no localStorage, ignora
      }
    }
    return config;
  });

  api.interceptors.response.use(
    (response) => response,
    (error) => {
      if (error.response && error.response.status === 401) {
        // No need to clear token from localStorage anymore
        navigate("/", { replace: true });
      }
      return Promise.reject(error);
    }
  );

  return api;
};

export default useApi;